module.exports = __webpack_public_path__ + "templates/navbar.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/templates/navbar.html
// module id = YFDK
// module chunks = 1